export class BaseError extends Error {
    static code;
    static statusCode;
    code;
    statusCode;
    reportToSentry = false;
    unmaskError = true;
    extensions;
    constructor(message, { cause, ...options } = {}) {
        super(message, { cause });
        this.code = this.constructor.code;
        this.name = this.code;
        this.statusCode = this.constructor.statusCode;
        this.extensions = options.extensions;
        this.reportToSentry = options.reportToSentry ?? this.reportToSentry;
    }
}
